import {TableDefinition} from '../../models';

/**
 * AI is the only package metered in tokens, so every other row shows a dash
 * rather than a misleading zero.
 */
const tokenCount = (value: unknown): string => {
  const num = Number(value ?? 0);
  if (!num) {
    return '—';
  }
  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(2)}M`;
  }
  if (num >= 1_000) {
    return `${(num / 1_000).toFixed(1)}k`;
  }
  return `${num}`;
};

export const BILLING_DETAIL_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'billing.billingDetail.tableColumn.id',
    prop: 'id',
    visible: false,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.element',
    prop: 'packageType',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'STRING',
    sortDisabled: true,
    valueKeyPrefix: 'billing.package'
  },
  {
    key: 'billing.billingDetail.tableColumn.planCost',
    prop: 'planCost',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.planUsage',
    prop: 'planUsage',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.usage',
    prop: 'usage',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.additionalCharges',
    prop: 'additionalCharges',
    visible: true,
    objectName: 'BillingDetail',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.costPerUse',
    prop: 'costPerUse',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },  
  {
    key: 'billing.billingDetail.tableColumn.tokenUsages',
    prop: 'tokenUsages',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true,
    transform: tokenCount
  },
  {
    key: 'billing.billingDetail.tableColumn.additionalTokens',
    prop: 'additionalTokens',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true,
    transform: tokenCount
  },
  {
    key: 'billing.billingDetail.tableColumn.due',
    prop: 'due',
    visible: true,
    objectName: 'BillingDetail',
    sortDisabled: true
  },
  {
    key: 'billing.billingDetail.tableColumn.totalDue',
    prop: 'totalDue',
    visible: true,
    objectName: 'BillingDetail',
    searchFieldType: 'NUMBER',
    sortDisabled: true
  },
];
